import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    mode: { type: String, default: "local" },
  };

  connect() {
    this.formatInLocalTimezone();
    this.element.title = "Click to toggle between local and UTC time";
  }

  formatInLocalTimezone() {
    const isoTime = this.element.getAttribute("datetime");
    if (!isoTime) return;

    const date = new Date(isoTime);

    const formatter = new Intl.DateTimeFormat(navigator.language, {
      dateStyle: "medium",
      timeStyle: "short",
      hour12: false, // Force 24-hour time format
    });

    this.element.textContent = formatter.format(date);

    this.element.textContent;
    this.modeValue = "local";
  }

  formatInUTC() {
    const isoTime = this.element.getAttribute("datetime");
    if (!isoTime) return;

    const date = new Date(isoTime);

    const formatter = new Intl.DateTimeFormat(navigator.language, {
      dateStyle: "medium",
      timeStyle: "short",
      timeZone: "UTC",
      hour12: false, // Force 24-hour time format
    });

    this.element.textContent = formatter.format(date) + " UTC";
    this.modeValue = "utc";
  }

  toggle() {
    if (this.modeValue === "local") {
      this.formatInUTC();
    } else {
      this.formatInLocalTimezone();
    }
  }
}
